// Copyright (c) 2025 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import RgaAdditionalDataTestParam from './rga-additional-data-test-param';
import t from 'tcomb';

const RgaAdditionalDataInfo = t.struct({
    dataParameters: t.maybe(t.list(RgaAdditionalDataTestParam, 'rgaAdditionalDataTestParam')),
    dataType: t.maybe(KeyValuePair),
    responsibleUnit: t.maybe(t.String),
    rgaNumber: t.maybe(t.String),
    testData: t.maybe(KeyValuePair)
}, {
    name: 'RgaAdditionalDataInfo',
    strict: true
});

export const getDefaultState = () => new RgaAdditionalDataInfo({
    dataParameters: [],
    dataType: getKeyValuePairDefaultState(),
    responsibleUnit: '',
    rgaNumber: '',
    testData: getKeyValuePairDefaultState()
});

export default RgaAdditionalDataInfo;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-additional-data-info.js